"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _UrlNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/UrlNugget"));

var _index = require("../../../../KESI2/Services/RemoteControlService/index");

var _FeatureManager = _interopRequireDefault(require("../../../../utils/features/FeatureManager"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _gwgStrings = require("../../Strings/gwgStrings");

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _Input = _interopRequireDefault(require("@material-ui/core/Input"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _index2 = _interopRequireDefault(require("../../Button/index"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _DrupalFormNugget = _interopRequireDefault(require("./DrupalFormNugget.scss"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _detectBrowser = require("detect-browser");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'formContainer_';
var EMAIL_OPTION_NAME = 'Ihre E-Mailadresse';

var DrupalFormNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalFormNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalFormNugget);

  function DrupalFormNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalFormNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setPrefilledValues", function () {
      var nugget = _this.state.content[_this.props.id];
      var fields = {};

      if (nugget.options) {
        nugget.options.forEach(function (option, index) {
          var optionParts = option.options.split('&&');

          if (option.type === '1' || option.type === '2') {
            // set prefilled values for radio buttons and dropdowns
            var availOptions;

            if (optionParts.length > 1) {
              availOptions = optionParts[1].split('|');
            } else {
              availOptions = optionParts[0].split('|');
            }

            fields[index] = {
              value: availOptions[0],
              fieldType: optionParts.length > 1 ? optionParts[0] : 'none'
            };
          }
        });
      }

      if (_config["default"].useLoginMailForGWGCert) {
        var userProfile = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.USER_PROFILE);

        var index = nugget.options.findIndex(function (option) {
          return option.name === EMAIL_OPTION_NAME;
        });

        if (userProfile && userProfile.email && index > -1) {
          fields[index] = {
            value: userProfile.email,
            fieldType: EMAIL_OPTION_NAME
          };
        }
      }

      console.log('prefilled fields', (0, _stringify["default"])(fields));

      _this.setState({
        fields: fields
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "changeData", function (e, index, type, option) {
      var fields = _this.state.fields;
      var fieldTypes = option.options.split('&&');
      fields[index] = {
        value: e.target.value,
        fieldType: fieldTypes[0]
      };
      console.log("setting value of index ".concat(index, " with type ").concat(type, " to ").concat(e.target.value, " and fieldType to ").concat(fieldTypes[0], "-> ").concat((0, _stringify["default"])(fields)));

      _this.setState({
        fields: fields
      });

      _this.forceUpdate();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sendData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var nugget, salutationKey, names, completeName, mailKey, optionKey, option, bccObj, bccOption, sentSuccesful, _option, _bccObj, _bccOption, _sentSuccesful;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              nugget = _this.state.content[_this.props.id];

              _this.setState({
                errorMessage: null
              });

              console.log(_this.state.fields, nugget.options);

              if (!(!_this.state.fields || (0, _keys["default"])(_this.state.fields).length < nugget.options.length)) {
                _context.next = 6;
                break;
              }

              _this.setState({
                errorMessage: (0, _gwgStrings.getString)('GWG_FILL_ALL_FIELDS')
              });

              return _context.abrupt("return");

            case 6:
              salutationKey = (0, _keys["default"])(_this.state.fields).find(function (optionKey) {
                return _this.state.fields[optionKey].fieldType === 'Anrede';
              });
              names = [];
              (0, _keys["default"])(_this.state.fields).forEach(function (optionKey) {
                if (_this.state.fields[optionKey].fieldType === 'Name') {
                  names.push(_this.state.fields[optionKey].value);
                }
              });

              if (names.length > 1) {
                completeName = names.join(' ');
              } else {
                completeName = names[0];
              }

              mailKey = (0, _keys["default"])(_this.state.fields).find(function (optionKey) {
                return _this.state.fields[optionKey].fieldType === 'Mail';
              });
              console.log("mailkey ".concat(mailKey, ", salutationKey ").concat(salutationKey, ", completeName ").concat(completeName));

              if (!(mailKey && salutationKey && completeName)) {
                _context.next = 25;
                break;
              }

              optionKey = (0, _keys["default"])(_this.state.fields).find(function (optionKey) {
                return _this.state.fields[optionKey].fieldType === 'Job';
              });
              option = ['Rechtsanwalt'];

              if (optionKey) {
                option = _this.state.fields[optionKey].value;
              }

              bccObj = _this.state.data[_DataStore.DATA_STORE_PATHS.GWG_BCC_ADRESSES] ? _this.state.data[_DataStore.DATA_STORE_PATHS.GWG_BCC_ADRESSES].find(function (type) {
                return option.indexOf(type.option) !== -1;
              }) : null;
              bccOption = bccObj && _this.state.bccAllowed ? bccObj.option : null; // showWideAlertHtml(`Folgende Daten würde gesendet werden:<br>Anrede: ${this.state.fields[salutationKey].value},<br>Name: ${completeName},<br>E-Mail: ${this.state.fields[mailKey].value},<br>BCC Optionen: ${bccOption}`, 'Info')

              console.log("sending: salutation: ".concat(_this.state.fields[salutationKey].value, ", name: ").concat(completeName, ", mail: ").concat(_this.state.fields[mailKey].value, ", bccOption: ").concat(bccOption));
              _context.next = 21;
              return _KESI2Helper["default"].sendCertificateMail(_this.state.fields[salutationKey].value, completeName, _this.state.fields[mailKey].value, bccOption);

            case 21:
              sentSuccesful = _context.sent;

              if (sentSuccesful) {
                _this.setState({
                  pageIndex: 1
                });

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.GWG_CERTIFICATE_SENT, true);
              } else {
                _this.setState({
                  errorMessage: (0, _gwgStrings.getString)('GWG_SEND_MAIL_ERROR')
                });
              }

              _context.next = 33;
              break;

            case 25:
              _option = (0, _keys["default"])(_this.state.fields).length > 3 ? _this.state.fields[3].value : ['Rechtsanwalt'];
              _bccObj = _this.state.data[_DataStore.DATA_STORE_PATHS.GWG_BCC_ADRESSES] ? _this.state.data[_DataStore.DATA_STORE_PATHS.GWG_BCC_ADRESSES].find(function (type) {
                return _option.indexOf(type.option) !== -1;
              }) : null;
              _bccOption = _bccObj && _this.state.bccAllowed ? _bccObj.option : null;
              console.log("sending: salutation: ".concat(_this.state.fields[0].value, ", name: ").concat(_this.state.fields[1].value, ", mail: ").concat(_this.state.fields[2].value, ", bccOption: ").concat(_bccOption)); // showWideAlertHtml(`Folgende Daten würde gesendet werden:<br>Anrede: ${this.state.fields[0].value},<br>Name: ${this.state.fields[1].value},<br>E-Mail: ${this.state.fields[2].value},<br>BCC Optionen: ${bccOption}`, 'Info')

              _context.next = 31;
              return _KESI2Helper["default"].sendCertificateMail(_this.state.fields[0].value, _this.state.fields[1].value, _this.state.fields[2].value, _bccOption);

            case 31:
              _sentSuccesful = _context.sent;

              if (_sentSuccesful) {
                _this.setState({
                  pageIndex: 1
                });

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.GWG_CERTIFICATE_SENT, true);
              } else {
                _this.setState({
                  errorMessage: (0, _gwgStrings.getString)('GWG_SEND_MAIL_ERROR')
                });
              }

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "toggleBccAllowed", function (e, checked) {
      _this.setState({
        bccAllowed: checked
      });
    });
    _this.state = _objectSpread({
      waitingForActivation: false,
      fields: {},
      options: {},
      pageIndex: 0,
      bccAllowed: true
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true;

    _this.props.registerNugget(_this.props.id, _UrlNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalFormNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.GWG_BCC_ADRESSES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalFormNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _UrlNugget["default"].CLASS, this.getDomId());
      this.setPrefilledValues();

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalFormNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join('!')), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join('!')] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
    /*
    componentWillUpdate (newProps, newState) {
      const nugget = newState.content[this.props.id]
       const active = DataStore.pathExists(`${this.props.id}.${this.props.contentPathArray.join(KESI_PATH_DELIMITER)}`, newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES])
        ? newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(KESI_PATH_DELIMITER)]
        : nugget.active
       if (newState.waitingForActivation && active !== this.active) {
        newState['waitingForActivation'] = false
      }
    }
    */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /**
       * @type {UrlNugget}
       */
      var nugget = this.state.content[this.props.id]; //options type 0 => input field, options type 1 => dropdown, options type 2 => radio

      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "formContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
        disabled: true,
        index: this.state.pageIndex,
        style: {
          margin: '20px 10%'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null, this.state.errorMessage ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalFormNugget["default"].error
      }, this.state.errorMessage) : null, nugget.options.map(function (option, index) {
        if (option.type === '0') {
          // input
          if (_config["default"].useLoginMailForGWGCert && option.name === EMAIL_OPTION_NAME) {
            // do not show email field as we use the login mail
            return null;
          }

          return /*#__PURE__*/_react["default"].createElement("input", {
            type: "text",
            placeholder: option.name,
            style: {
              display: 'block',
              width: '80%',
              margin: '30px 10%',
              fontSize: '17px',
              padding: '5px'
            },
            onChange: function onChange(e) {
              return _this2.changeData(e, index, option.type, option);
            }
          });
        } else if (option.type === '1') {
          // dropdown
          var optionParts = option.options.split('&&');
          var options;

          if (optionParts.length > 1) {
            options = optionParts[1].split('|');
          } else {
            options = optionParts[0].split('|');
          }

          var bccObj = _this2.state.data[_DataStore.DATA_STORE_PATHS.GWG_BCC_ADRESSES] ? _this2.state.data[_DataStore.DATA_STORE_PATHS.GWG_BCC_ADRESSES].find(function (type) {
            return (_this2.state.fields[index] ? _this2.state.fields[index].value : options[0]).indexOf(type.option) !== -1;
          }) : null;

          if (options.length > 1) {
            var browser = (0, _detectBrowser.detect)();
            return /*#__PURE__*/_react["default"].createElement("div", null, option.name ? /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                display: 'block',
                width: '80%',
                margin: '10px 10%',
                fontSize: '17px',
                padding: '5px'
              }
            }, option.name) : null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
              style: {
                display: 'block',
                width: '80%',
                margin: '30px 10%',
                fontSize: '17px',
                padding: '5px'
              },
              onChange: function onChange(e) {
                _this2.changeData(e, index, option.type, option);
              },
              value: _this2.state.fields[index] ? _this2.state.fields[index].value : options[0],
              input: /*#__PURE__*/_react["default"].createElement(_Input["default"], {
                name: "dropdown_".concat(index),
                id: "dropdown_".concat(index)
              }),
              "native": window.outerWidth < 600 || _DeviceInfoHelper["default"].isBrowser() && browser.name === 'ios' || _DeviceInfoHelper["default"].isInternetExplorer()
            }, options.map(function (dropdownOption) {
              return /*#__PURE__*/_react["default"].createElement("option", {
                key: dropdownOption,
                value: dropdownOption
              }, dropdownOption);
            })), _config["default"].showBccOptions && bccObj ? /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                textAlign: 'center'
              }
            }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
              onChange: _this2.toggleBccAllowed,
              checked: _this2.state.bccAllowed,
              style: {
                display: 'inline-block',
                verticalAlign: 'top'
              },
              classes: {
                colorSecondary: _DrupalFormNugget["default"].muiColor
              }
            }), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                display: 'inline-block',
                marginTop: '2px',
                verticalAlign: 'top'
              }
            }, (0, _gwgStrings.getString)('SEND_BCC_COPY_TO', [bccObj.bcc]))) : null);
          }
        } else {
          // radio
          var _optionParts = option.options.split('&&');

          var _options;

          if (_optionParts.length > 1) {
            _options = _optionParts[1].split('|');
          } else if (_optionParts.length === 1) {
            _options = _optionParts[0].split('|');
          }

          console.log('radio options', _options);

          if (_options.length > 1) {
            return /*#__PURE__*/_react["default"].createElement("div", null, option.name ? /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                display: 'block',
                width: '80%',
                margin: '10px 10%',
                fontSize: '17px',
                padding: '5px'
              }
            }, option.name) : null, /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], {
              style: {
                display: 'block',
                width: '80%',
                margin: '30px 10%',
                fontSize: '17px',
                padding: '5px'
              },
              onChange: function onChange(e) {
                _this2.changeData(e, index, option.type, option);
              },
              value: _this2.state.fields[index] ? _this2.state.fields[index].value : _options[0]
            }, _options.map(function (radioOptions) {
              return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
                key: radioOptions,
                value: radioOptions,
                control: /*#__PURE__*/_react["default"].createElement(_Radio["default"], {
                  classes: {
                    colorSecondary: _DrupalFormNugget["default"].muiColor
                  }
                }),
                label: radioOptions
              });
            })));
          }
        }
      }), /*#__PURE__*/_react["default"].createElement(_index2["default"], {
        className: _DrupalFormNugget["default"].sendButton,
        onClick: this.sendData
      }, (0, _gwgStrings.getString)('SEND_DATA'))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalFormNugget["default"].info,
        dangerouslySetInnerHTML: {
          __html: (0, _gwgStrings.getString)('GWG_CERTIFICATE_SENT')
        }
      })))));
    }
  }]);
  return DrupalFormNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalFormNugget;
DrupalFormNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired
};
DrupalFormNugget.defaultProps = {
  id: null
};